import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";

//localization
import de from "../../i18n/de";
import en from "../../i18n/en";

const messages = {
  en: en,
  de: de
};

const LocaleProvider = ({ children, language }) => {
  const lang = language || "de";

  return (
    <IntlProvider locale={lang} defaultLocale="de" messages={messages[lang]} textComponent={React.Fragment}>
      {children}
    </IntlProvider>
  );
};

LocaleProvider.propTypes = {
  language: PropTypes.string.isRequired,
  children: PropTypes.element
};

export default LocaleProvider;
